import { useCallback, useState } from 'react';
import { useScopeStorageKey } from '@/shared/object-scope';
import { useMediaQuery } from '@/shared/hooks/useMediaQuery';

const SIDEBAR_STORAGE = 'stayon.sidebar-collapsed';

function read(key: string | null): boolean | null {
  if (!key) return null;
  try {
    const value = localStorage.getItem(key);
    return value === null ? null : value === 'true';
  } catch {
    return null;
  }
}

function write(key: string | null, collapsed: boolean): void {
  if (!key) return;
  try {
    localStorage.setItem(key, String(collapsed));
  } catch {
    // Ohne Speicher (privates Fenster) gilt der Zustand nur bis zum Neuladen.
  }
}

/**
 * Seitenleiste ein- oder ausgeklappt. Ohne gespeicherte Wahl startet sie am Desktop ausgeklappt
 * und am Tablet eingeklappt; die Wahl gehört dem Benutzer im Workspace, wie die Objektwahl.
 */
export function useSidebarCollapsed(): [boolean, () => void] {
  const key = useScopeStorageKey(SIDEBAR_STORAGE);
  const tablet = useMediaQuery('(max-width: 1279px)');
  const [choice, setChoice] = useState<boolean | null>(() => read(key));
  const collapsed = choice ?? tablet;
  const toggle = useCallback(() => {
    setChoice(!collapsed);
    write(key, !collapsed);
  }, [collapsed, key]);
  return [collapsed, toggle];
}
